export default __webpack_public_path__ + "static/media/project9.4e758028.PNG";